import { store } from '@/state/store';
import { LOCAL__ui_grids2d_set_current_cell } from '@/state/ui/image/LOCAL__ui_grids2d_set_current_cell';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';

export function FN_IMAGE_ASSET__add_to_grid2d_gallery(images_map: Map<string, DTO__image_asset>) {
  let { global__grid2d_gallery_cell_current } = store.getState().slice_ui;

  if (global__grid2d_gallery_cell_current.is_stub()) return; //nothing to update
  if (!global__grid2d_gallery_cell_current.image.is_stub()) return; //already initialized

  if (!images_map.has(global__grid2d_gallery_cell_current.hash_sha256_content)) return; //not loaded yet

  let image = images_map.get_or_assert(global__grid2d_gallery_cell_current.hash_sha256_content);
  global__grid2d_gallery_cell_current.image = image.clone();

  store.dispatch(LOCAL__ui_grids2d_set_current_cell(global__grid2d_gallery_cell_current));
}
